function isPlainObjectRecord(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

function normalizeStoryboardMediaUrlForCacheComparison(value) {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  try {
    const parsed = new URL(trimmed, 'https://dobidobi.local');
    const proxiedUrl = parsed.pathname === '/api/assets/proxy/download'
      ? parsed.searchParams.get('url')
      : null;
    if (proxiedUrl) {
      return decodeURIComponent(proxiedUrl).trim();
    }

    return parsed.toString();
  } catch {
    return trimmed;
  }
}

function isStoryboardPanelImageCacheCurrent(storyboard, currentBoardImageUrl) {
  if (!isPlainObjectRecord(storyboard)) {
    return true;
  }

  const storedBoardImageUrl = normalizeStoryboardMediaUrlForCacheComparison(storyboard.board_image_url);
  const normalizedCurrentBoardImageUrl = normalizeStoryboardMediaUrlForCacheComparison(currentBoardImageUrl);
  return !storedBoardImageUrl || !normalizedCurrentBoardImageUrl || storedBoardImageUrl === normalizedCurrentBoardImageUrl;
}

function clearPanelRecordImageCache(panel) {
  if (!isPlainObjectRecord(panel)) {
    return panel;
  }

  const nextPanel = { ...panel };
  delete nextPanel.frame_url;
  delete nextPanel.image_url;
  delete nextPanel.url;
  return nextPanel;
}

function invalidateStoryboardPanelImageCacheForBoardImage(storyboard, boardImageUrl) {
  if (!isPlainObjectRecord(storyboard)) {
    return storyboard;
  }

  const nextStoryboard = {
    ...storyboard,
    board_image_url: boardImageUrl,
    selected_frame_urls: [],
    editable_panel_image_urls: [],
    editable_panel_node_ids: [],
  };

  if (Array.isArray(storyboard.shots)) {
    nextStoryboard.shots = storyboard.shots.map(clearPanelRecordImageCache);
  }

  if (Array.isArray(storyboard.panels)) {
    nextStoryboard.panels = storyboard.panels.map(clearPanelRecordImageCache);
  }

  if (isPlainObjectRecord(storyboard.grid_panel_edit)) {
    const nextGridPanelEdit = { ...storyboard.grid_panel_edit };
    delete nextGridPanelEdit.split_node_ids;
    nextStoryboard.grid_panel_edit = nextGridPanelEdit;
  }

  return nextStoryboard;
}

module.exports = {
  invalidateStoryboardPanelImageCacheForBoardImage,
  isStoryboardPanelImageCacheCurrent,
  normalizeStoryboardMediaUrlForCacheComparison,
};